export default {
  title: 'Rapoarte de venituri',
  sections: {
    new_report: 'Raport nou',
  },
  form: {
    period: {
      label: 'Perioadă',
    },
  },
  buttons: {
    export: 'Export',
  },
  toasts: {
    failed_to_create_report: 'Generarea raportului a eșuat',
  },
};
